import React, { useState } from 'react'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'

import Tab from './Tab'
import BlogPostSlider from '../BlogPostSlider'
import { Arrow } from '../../assets/svg/criticalSVG'

const StyledWrapper = styled.div`
  margin: 12px 20px 0;

  ${({ theme }) => theme.media.tablet} {
    margin: 12px 80px 0;
  }

  ${({ theme }) => theme.media.desktop} {
    margin: 12px auto 48px;
  }
`

const StyledTabListWrapper = styled.div`
  height: 55px;
  left: -20px;
  margin: 0 auto;
  max-width: 1029px;
  overflow: hidden;
  position: relative;
  width: calc(100% + 40px);

  :after {
    background: #8a94a6;
    bottom: 0;
    content: '';
    height: 1px;
    left: 20px;
    opacity: 0.1;
    position: absolute;
    width: 100%;
  }

  ${({ theme }) => theme.media.tablet} {
    left: 0;
    width: 100%;

    :after {
      left: 0;
    }
  }

  ${({ theme }) => theme.media.desktop} {
    height: 65px;
  }
`

const StyledTabList = styled.ul`
  -webkit-overflow-scrolling: touch;
  box-sizing: content-box;
  display: flex;
  height: 55px;
  overflow-x: scroll;
  padding: 0 0 17px 20px;
  position: relative;
  scroll-behavior: smooth;

  ::-webkit-scrollbar {
    display: none;
  }

  ${({ clicked }) =>
    !clicked &&
    css`
      > li:first-child:after {
        background: #c02428;
        bottom: -2px;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        width: 100%;
      }
    `}

  ${({ theme }) => theme.media.tablet} {
    padding: 0 0 17px;
    width: 100%;
  }

  ${({ theme }) => theme.media.desktop} {
    height: 65px;
    overflow-x: hidden;
  }
`

const StyledAdditionalTab = styled(props => <Link {...props} />)`
  color: #8a94a6;
  display: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;
  padding: 20px 24px;
  position: absolute;
  right: 0;
  top: 0;

  svg {
    transform: rotate(-90deg);

    path {
      fill: #8a94a6;
    }
  }

  ${({ theme }) => theme.media.desktop} {
    display: block;
  }
`

const StyledMark = styled.div`
  background: #c02428;
  bottom: 17px;
  height: 2px;
  left: ${({ position }) => position};
  position: absolute;
  transition: all 0.4s ease;
  width: ${({ width }) => width};
`

const StyledContentWrapper = styled.div`
  padding: 40px 0;
`

const StyledContent = styled.div`
  display: ${({ active }) => (active ? 'flex' : 'none')};
  flex-wrap: wrap;

  a > {
    width: 33%;
  }
`

const SegmentedControl = ({ tabList, additionalTab, additionalTabLink }) => {
  const [activeTab, setActiveTab] = useState(0)
  const [markPosition, setMarkPosition] = useState(0)
  const [markWidth, setMarkWidth] = useState('120px')
  const [tabListClicked, setTabListClicked] = useState(false)

  const handleClick = (e, index) => {
    setActiveTab(index)
    setMarkPosition(e.target.offsetLeft + 'px')
    setMarkWidth(e.target.clientWidth + 'px')
    setTabListClicked(true)
  }

  return (
    <StyledWrapper>
      <StyledTabListWrapper>
        <StyledTabList clicked={tabListClicked}>
          {tabList.map((tab, index) => (
            <Tab key={tab.id} onClick={e => handleClick(e, index)}>
              {tab.title}
            </Tab>
          ))}
          <StyledMark position={markPosition} width={markWidth} />
        </StyledTabList>
        <StyledAdditionalTab to={additionalTabLink}>
          {additionalTab} <Arrow />
        </StyledAdditionalTab>
      </StyledTabListWrapper>
      <StyledContentWrapper>
        {tabList.map((tab, index) => {
          return (
            <StyledContent key={tab.id} active={index === activeTab}>
              <BlogPostSlider data={tab.content} />
            </StyledContent>
          )
        })}
      </StyledContentWrapper>
    </StyledWrapper>
  )
}

SegmentedControl.propTypes = {
  tabList: PropTypes.array.isRequired,
}

export default SegmentedControl
